<div class="modal-container">
  <div class="modal-content">
    <h1 class="modal-title">Confirm Peripheral Deletion</h1>
    <div class="modal-description">
      <div class="select_config_file_detail">
        <ul>
          <li><span class="configLable">Model:</span> <span class="configValues">{{data?.product?.model}}<span *ngIf="data?.product?.make">-{{data?.product?.make}}</span></span></li>
          <li><span class="configLable">Location:</span> <span class="configValues">{{data?.locationName || 'N/A'}}</span></li>
          <li><span class="configLable">Peripheral Id:</span> <span class="configValues">{{data?.peripheralId || 'N/A'}}</span></li>
          <li><span class="configLable">MAC Address:</span> <span class="configValues">{{data?.macAddress || 'N/A'}}</span></li>
        </ul>
      </div>
    </div>
    <div class="button-container">
      <button type="button" class="btn-cancel" (click)="onCancel()">Cancel</button>
      <button type="button" class="btn-confirm" (click)="onConfirm()">Delete</button>
    </div>
  </div>
</div>

